import { Component, Input } from '@angular/core';

@Component({
  selector: 'ling-page-side-column',
  templateUrl: './page-side-column.component.html',
  styleUrls: ['./page-side-column.component.scss'],
})
export class PageSideColumnComponent {
  @Input() title = '';
  @Input() noPadding = false;
}
